/**
 * C 端「正在匹配对手单 / 唤醒做市」提示门控。
 * 仅当展示簿无真实做市流动性时提示（mock / empty / maker_empty）。
 * live / maker_hold 表示当前或短窗内有真实簿，不提示。
 *
 * 各盘口类型（分钟盘 / 二元 / 体育腿 / 多元）共用同一判定：
 * 对「当前下单 outcome」拉 GET /order/depth，再看 displayState——不要用 UI isEmpty（mock 仍可能有梯子）。
 *
 * @param {object|null|undefined} payload GET /order/depth 的 data
 * @returns {boolean}
 */
export function needsMmWakeMatchingHint(payload) {
  if (!payload || typeof payload !== 'object') return false;
  const state = String(payload.displayState ?? '')
    .trim()
    .toLowerCase();
  if (state === 'live' || state === 'maker_hold') return false;
  if (state === 'mock' || state === 'empty' || state === 'maker_empty') return true;
  const bids = Array.isArray(payload.bids) ? payload.bids : [];
  const asks = Array.isArray(payload.asks) ? payload.asks : [];
  return bids.length === 0 && asks.length === 0;
}

export function isPmMarketNoOppositeDepthError(err) {
  return (err?.data?.reason ?? err?.response?.data?.data?.reason) === 'PM_MARKET_NO_OPPOSITE_DEPTH';
}

/**
 * 后端拒单/提示：暂无对手盘、唤醒做市等（勿把原文抛给 SurfaceHint）。
 * @param {unknown} err
 * @returns {boolean}
 */
export function isMmWakeMatchingBackendError(err) {
  if (isPmMarketNoOppositeDepthError(err)) return false;
  if (!err || typeof err !== 'object') return false;
  const raw = [
    err.tradeUserMessage,
    err.message,
    err.msg,
    err.response?.data?.msg,
    err.response?.data?.message,
  ]
    .filter(Boolean)
    .map((v) => String(v))
    .join(' ');
  if (!raw.trim()) return false;
  return /暂无对手|对手盘|唤醒做市|匹配对手|改用限价|Matching the latest opposite|30\s*[–\-]\s*60|no\s*counterpart|opposing\s*(order|quote|book)|wake\s*(up\s*)?(the\s*)?market\s*maker|use\s*a?\s*limit\s*order|maker[_ ]?empty/i.test(
    raw
  );
}
